import React, { Fragment } from 'react';

import { normalizeNameOfPerson } from '@utils/normalize/normalizeNameOfPerson';

// Components

import SummaryItem from '../SummaryItem';

// Utils

import { transformDropdownOptionsToObject } from '@utils/normalize/transformDropdownOptionsToObject';
import { questionsVisibility } from '@utils/miscellaneous/pageAndQuestionsVisibility';

// Constants

import { DROPDOWN_OPTIONS} from '@constants/ssap/hhmTypes/dropdownOptions';

const AdditionalInformationInfo = props => {

    const {
        alwaysDisplayMedicaidQuestions,
        idx,
        inlineCurrentIncomeEnabled,
        isState,
        healthCoverage: {
            eligibleITU,
            receivedITU,
            unpaidBill,
            absentParent
        },
        mcoSelection,
        name,
        isIndianHealthServicesShown,
        preliminaryMedicaidStatus
    } = props;

    const params = {
        alwaysDisplayMedicaidQuestions,
        inlineCurrentIncomeEnabled,
        isState,
        preliminaryMedicaidStatus
    };

    const isMcoSelectionShown = questionsVisibility.isMcoSelectionShown(params);

    const replacements = { personName: normalizeNameOfPerson(name) };

    const options = transformDropdownOptionsToObject(DROPDOWN_OPTIONS.MCO_SELECTIONS);

    const secureValue = value => {
        if(value === undefined) return 'NOT_PROVIDED';
        return value;
    };

    const getMcoSelection = value => {
        return secureValue(options[value]);
    };

    return (
        <Fragment>
            {
                (eligibleITU !== null && isIndianHealthServicesShown) &&

                <SummaryItem
                    category = 'ssap.additional_info.summary.eligible_for_tribal_program'
                    value = { eligibleITU }
                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ idx }].healthCoverage.eligibleITU`
                            ]
                        ]
                    }
                />
            }
            {
                (receivedITU !== null && isIndianHealthServicesShown) &&

                <SummaryItem
                    category = 'ssap.additional_info.summary.services_from_tribal_program'
                    value = { receivedITU }
                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ idx }].healthCoverage.receivedITU`
                            ]
                        ]
                    }
                />
            }
            {
                unpaidBill !== null &&

                <SummaryItem
                    category = 'ssap.additional_info.summary.medical_bills'
                    value = { unpaidBill }
                    replacements = { replacements }
                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ idx }].healthCoverage.unpaidBill`
                            ]
                        ]
                    }
                />
            }
            {
                absentParent !== null &&

                <SummaryItem
                    category = 'ssap.additional_info.summary.parents_live_outside'
                    value = { absentParent }
                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ idx }].healthCoverage.absentParent`
                            ]
                        ]
                    }
                />
            }

            {
                isMcoSelectionShown &&

                <SummaryItem
                    category = 'ssap.input.legend.mco_selection'
                    value = { getMcoSelection(mcoSelection) }
                    replacements = { replacements }
                    desc = {
                        [
                            [
                                `taxHousehold.householdMember[${ idx }].mcoSelection`,
                                getMcoSelection
                            ]
                        ]
                    }
                />
            }
        </Fragment>
    );
};

export default AdditionalInformationInfo;